import Conditions from '../constants/conditions';
import OrdersComponents from '../../permissions/constants/ordersComponents';
import UserPermissions from '../constants/userPermissions';
import { PartialRecord, PermissionRules } from '../usePermissions';

type ordersComponentRegistry = {
  [name in OrdersComponents]: PermissionRules;
};

const OrdersComponentRegistry: ordersComponentRegistry = {
  DraggableVisitsLayer : {
    [UserPermissions.ASSIGN_STOPS_TO_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  AddOrdersButton: {
    [UserPermissions.CREATE_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  OrderDetailsPanel: {
    [UserPermissions.VIEW_CUSTOMERS]: true,
    [UserPermissions.ASSIGN_STOPS_TO_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.EDIT_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.DELETE_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.CREATE_OPTIMIZATION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
    [UserPermissions.CREATE_CUSTOMERS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  OrdersScheduleButton: {
    [UserPermissions.CREATE_OPTIMIZATION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
  },
  ScheduledTo: {
    [UserPermissions.ASSIGN_STOPS_TO_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  UnscheduledVisitsPanel: {
    [UserPermissions.CREATE_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.VIEW_VISITS]: true,
  },
  UnscheduledVisitsTable: {
    [UserPermissions.CREATE_OPTIMIZATION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.EDIT_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.DELETE_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  VisitsMultiSelectActionBar: {
    [UserPermissions.CREATE_OPTIMIZATION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.EDIT_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.DELETE_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.CREATE_CUSTOMERS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  CustomerProfilesTable: {
    [UserPermissions.VIEW_VISITS]: true,
    [UserPermissions.CREATE_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.EDIT_CUSTOMERS]: true,
    [UserPermissions.DELETE_CUSTOMERS]: true,
  },
};

export default OrdersComponentRegistry;
